import { useEffect } from "react";
import { useCartService } from "../../../hooks/use-cart-service";
import {
	getCookie,
	handleCookieConsent,
	setCookie,
} from "../../cookies/cookie-service";
import { getQueryStringParam } from "../../query-string";

export const useMeta = () => {
	const { cart, setCartCustomField, cartLoading } = useCartService();

	const clickIdParam = getQueryStringParam("fbclid");
	const clickIdCookie = getCookie("_fbc");
	const browserId = getCookie("_fbp");

	// Register cookie for consent management
	useEffect(() => {
		handleCookieConsent("_fbc", "targeting");
	}, []);

	useEffect(() => {
		// Only set the cookie if the fbclid in URL is new or different
		if (!clickIdParam) return;

		const urlLastSegment = clickIdParam.split(".").at(-1);
		const cookieLastSegment = clickIdCookie?.split(".").at(-1);

		if (!clickIdCookie || urlLastSegment !== cookieLastSegment) {
			setCookie({
				name: "_fbc",
				value: clickIdParam,
				requireConsent: "targeting",
				attributes: {
					expires: 90,
				},
			});
		}
	}, [clickIdParam, clickIdCookie]);

	// Update cart with click ID if needed
	useEffect(() => {
		if (cartLoading || !clickIdCookie) return;

		const cookieLastSegment = clickIdCookie.split(".").at(-1);
		const cartLastSegment = cart?.custom.fields.metaClickId?.split(".").at(-1);

		if (cookieLastSegment !== cartLastSegment) {
			setCartCustomField("metaClickId", clickIdCookie).catch((error) =>
				console.error("Failed to set Meta click ID:", error),
			);
		}
	}, [cart, cartLoading, clickIdCookie, setCartCustomField]);

	// Update cart with browser ID if needed
	useEffect(() => {
		if (cartLoading || !browserId) return;

		if (browserId !== cart?.custom.fields.metaBrowserId) {
			setCartCustomField("metaBrowserId", browserId).catch((error) =>
				console.error("Failed to set Meta browser ID:", error),
			);
		}
	}, [browserId, cart, cartLoading, setCartCustomField]);
};
